export default __webpack_public_path__ + "static/20220628-cdb4b92c12f3562774b43a472105a2dc.png";